import { TableV3Filters } from 'common/table/components/TableV3';

export const hasTableV3Filters = <T>(
  filters: TableV3Filters<T> | undefined
): boolean => {
  if (!filters) return false;

  const hasSearchFields =
    filters.searchFields && Object.keys(filters.searchFields).length > 0;
  const hasFilterValues =
    filters.filterValues && Object.keys(filters.filterValues).length > 0;

  return Boolean(hasSearchFields || hasFilterValues);
};
